<template>
<div class="grid py-2 dragindicator">
<div class="col-9">
<router-link class="text-pink-500 mt-1 mb-0 pt-1 font-bold no-underline" :to="{ name: 'BrandReport' , params: { report_id: report.id }}">{{getTheTranslation(report,"translation")}}</router-link>
</div>
<div class="col-2">
<ReportProgersssBar :data="report"></ReportProgersssBar>
</div>
<div class="col-1">
<Button type="button"  icon="pi pi-ellipsis-h" @click="toggleMenu" aria-haspopup="true" :aria-controls="'line_menu'+report.id" class="p-button-primary p-button-text p-button-sm mt-0"   />
<Menu :id="'line_menu'+report.id" ref="menu" :model="menuitems" :popup="true">
<template #item="{item}">  
<a class="p-menuitem-link" role="menuitem" @click="item.command(report.id)">
<span :class="'p-menuitem-icon '+item.icon"></span>
<span class="p-menuitem-text">{{item.label}}</span>
<span class="p-ink"></span></a>
</template>
</Menu>
</div>
</div>
</template>

<script>
export default {

  name: 'BrandReportLine',
  props:["report"],
  data () {
    return {
    	menuitems: [
        {
            label: 'Düzenle',
            icon: 'pi pi-pencil',
            command: (id) => {
                 this.gotoPage("BrandReport", { report_id:id })
              }
        },
        {
            label: 'Öncelikli Hesapla',
            icon: 'pi pi-bolt',
            command: (id) => {
                 this.calculateReportAhead(id)
                 this.$refs.menu.hide();
              }
        },
        {
            label: 'Sil',
            icon: 'pi pi-trash',
            command: (id) => {
                console.log(id)
                 this.deleteItem("brand_report",id)
              }
        },
      ],
    }
  },
  methods:{
    calculateReportAhead(id)
    {
        let formdata = new FormData()
        this.generalSubmission(formdata,"calculate_report_ahead/"+id,this.aftercalculateReportAhead)
    },
    aftercalculateReportAhead(response)
    {
        console.log(response.data)
    },
    test(event)
    {
        event.preventDefault()
        console.log("test")
        console.log(event)
        let href = this.$route.href
        href = href.replace("reports","report/")
        href = window.location.origin+href+this.report.id
        window.open(href, "_blank");
    },
  	toggleMenu(event) {
      this.$refs.menu.toggle(event);
    },
    gotoItem()
    {
    	this.gotoPage("BrandReport", { report_id:this.report.id })
    },
  }
}
</script>

<style lang="css" scoped>
.dragindicator{
	cursor: pointer;
}
</style>